import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { requestToggleActiveStateSpace } from "services/settings/spaceAdmin/aboutSpaceAdmin";
import { FORM_ACTION_ERRORS } from "../../components/RegisterSpaceForm/utils/constants";
import useMainContext from "utils/context/useMainContext";

function getMessageAction(newActive) {
    return newActive 
        ? {
            loading: "Activando",
            success: "activado"
        }
        : {
            loading: "Desactivando",
            success: "desactivado"
        };
}
const useToggleSpaceActive = ({
	form, spaceSelected,
	loadingRequest,
    onSuccess
}) => {
    const dialogConfirmDesactivate = useShowDialogAlert();
    const dialogErrorForFutureReservationsInDesactivation = useShowDialogAlert();
	const mainContext = useMainContext();
	async function toggleActive(newActive) {
        dialogConfirmDesactivate.hide();
        const messageAction = getMessageAction(newActive);
        loadingRequest.show(`${messageAction.loading} espacio...`);
        const { success, message } = await requestToggleActiveStateSpace({
            spaceId: form.value.id,
            active: newActive
        });
        loadingRequest.hide();
        if (success) {
            onSuccess(newActive, `¡Espacio ${messageAction.success} con éxito!`);
            return;
        }
        changeFieldActive(!form.value.active);
        switch (message) {
            case FORM_ACTION_ERRORS.FUTURE_RESERVATIONS:
                dialogErrorForFutureReservationsInDesactivation.set(true);
                return;
            default:
                mainContext.setShowDialogUnexpectedError();
        }
    }
    function changeFieldActive(value) {
        form.change("active", value);
    }
    function cancelDesactivation() {
        changeFieldActive(true);
        dialogConfirmDesactivate.hide();
    }
	function toggleActiveFromField() {
        if (spaceSelected.isEmpty()) 
            throw new Error("Couldn't toggle active state because space not exist");
        const newActive = !form.value.active;
        if (!newActive) {
            changeFieldActive(false);
            dialogConfirmDesactivate.open();
            return;
        }
        toggleActive(true);
    }
	return {
		dialogs: {
			dialogConfirmDesactivate,
			dialogErrorForFutureReservationsInDesactivation
		},
		toggleActive,
		toggleActiveFromField,
		cancelDesactivation
	};
}	
	
export default useToggleSpaceActive;